

import React from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import styles from './label.module.css';

interface LabelProps {
  htmlFor: string;
  text: string;
  width?: string;
}

const LabelWrapper = styled.div<{ width?: string }>`
  width: ${({ width }: any) => width ?? '150px'};
`;

export const Label: React.FC<LabelProps> = ({ htmlFor, text, width }) => (
  <label
    className={cn(styles.label)}
    htmlFor={htmlFor}
    style={{ width: width ?? '150px' }}
  >
    {text}
  </label>
);

export const FormLabelWrapper: React.FC<LabelProps> = ({ htmlFor, text, width }) => (
  <LabelWrapper width={width}>
    <Label htmlFor={htmlFor} text={text} width={width} />
  </LabelWrapper>
);

export default Label;
